import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';
import SparqlSelectResultsViewer from './SparqlSelectResultsViewer';

class SparqlResultsViewer extends React.Component {

    render() {

        const { data, queryType } = this.props;
        
        switch (queryType) {
            case "ASK": return <Typography style={{paddingTop: 12}} data-test="ask-result" variant="body2">{data.boolean === true ? "TRUE" : "FALSE"}</Typography>;
            case "DESCRIBE": return <pre data-test="describe-result" style={{overflowX: 'scroll', paddingBottom: 12}}>{data}</pre>;
            default: return <SparqlSelectResultsViewer data={data} />;
        }
    }
}

SparqlResultsViewer.defaultProps = {
};

SparqlResultsViewer.propTypes = {
    queryType: PropTypes.string,
    data: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    classes: PropTypes.object
};

export default withStyles(styles)(SparqlResultsViewer);